import axios from "axios";
import authHeader from "./auth-header";
import { isTokenExpired, sanitizeBusiness, sanitizeSession } from "../utils/session";
import { clearPendingOrder } from "../utils/pending-order";

const API_URL = process.env.REACT_APP_API_URL;

class AuthService {
  login(cellphone, password) {
    return axios
      .post(API_URL + "auth/login", {
        cellphone,
        password,
      })
      .then((response) => {
        this.saveSession(response.data);
        return response.data;
      });
  }

  requestOtp(cellphone) {
    return axios
      .post(API_URL + "auth/otp/send", { cellphone })
      .then((response) => response.data);
  }

  verifyOtp(cellphone, code) {
    return axios
      .post(API_URL + "auth/otp/verify", { cellphone, code })
      .then((response) => {
        this.saveSession(response.data);
        return response.data;
      });
  }

  sendRegistrationOtp(phone_number) {
    return axios
      .post(API_URL + "phone_verifications/send_code", { phone_number })
      .then((response) => response.data);
  }

  verifyRegistrationOtp(phone_number, code) {
    return axios
      .post(API_URL + "phone_verifications/verify_code", { phone_number, code })
      .then((response) => response.data);
  }

  logout() {
    localStorage.removeItem("user");
    clearPendingOrder();
    window.dispatchEvent(
      new CustomEvent("auth-change", { detail: { type: "logout" } }),
    );
  }

  ResetPassword(password, reset_token) {
    return axios.post(API_URL + "auth/reset_password/" + reset_token, {
      password,
    });
  }

  ResetRequest(email, source = "parcelin") {
    return axios.post(API_URL + "auth/reset_password", {
      email,
      source,
    });
  }

  createBusiness(business) {
    return axios
      .post(API_URL + "businesses", business, { headers: authHeader() })
      .then((response) => response.data);
  }

  register(
    cellphone,
    first_name,
    last_name,
    role,
    gender,
    email,
    password,
    referral_key,
    source = 1,
  ) {
    return axios
      .post(API_URL + "users", {
        cellphone,
        first_name,
        last_name,
        role,
        email,
        gender,
        password,
        referral_key,
        source,
      })
      .then((response) => {
        this.saveSession(response.data);
        return response.data;
      });
  }

  isLogin() {
    const currentUser = this.getCurrentUser();
    return Boolean(currentUser) && !isTokenExpired(currentUser.token);
  }

  getCurrentUser() {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      localStorage.removeItem("user");
      return null;
    }
  }

  saveSession(session) {
    if (!session?.token) return;
    localStorage.setItem("user", JSON.stringify(sanitizeSession(session)));
    window.dispatchEvent(
      new CustomEvent("auth-change", { detail: { type: "login" } }),
    );
  }

  updateStoredUser(changes) {
    const stored = this.getCurrentUser();
    if (!stored?.user) return null;
    this.saveSession({ ...stored, user: { ...stored.user, ...changes } });
    return this.getCurrentUser().user;
  }

  refreshUserWithBusiness(newBusiness) {
    const stored = this.getCurrentUser();
    if (!stored?.user) return;
    const businesses = (stored.user.businesses ?? []).filter(
      (business) => business.id !== newBusiness.id,
    );
    this.updateStoredUser({
      businesses: [...businesses, sanitizeBusiness(newBusiness)],
    });
  }
}

export default new AuthService();
